import React from "react";
import { Helmet } from 'react-helmet-async';
import '../../../assets/styles/Estimation.css'
import estimationHero from "../../../assets/images/Cost Estimator.png";
import estimationTools from "../../../assets/images/Cost Estimator.png";

const EstimationPage = () => {
  return (
    <>
      <Helmet>
        {/* <!-- Primary Meta Tags for SEO --> */}
        <title> Estimation Services – BuddyTech Solutions </title>
        <meta name="description" content="Accurate BOQ and budget forecasting to optimize project costs." />
        <meta name="keywords" content="BOQ, cost estimation, construction budgeting" />

        {/* <!-- Open Graph / Facebook Meta Tags --> */}
        <meta property="og:title" content="Estimation Services – BuddyTech Solutions" />
        <meta property="og:description" content="Accurate BOQ and budget forecasting to optimize project costs." />
        <meta property="og:keywords" content="BOQ, cost estimation, construction budgeting" />
        <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
        <meta property="og:url" content="https://buddytechsolutions.in/services/constructions/estimation" />
        <meta property="og:type" content="website" />

        {/* <!-- Optional: Facebook App ID --> */}
        {/* <!-- <meta property="fb:app_id" content="your_facebook_app_id" /> --> */}

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Estimation Services – BuddyTech Solutions" />
        <meta name="twitter:description" content="Accurate BOQ and budget forecasting to optimize project costs." />
        <meta name="twitter:keywords" content="BOQ, cost estimation, construction budgeting" />
        <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
      </Helmet>
      <div className="estimation-container">
        <header className="estimation-hero">
          <div className="estimation-hero-content">
            <h1>Construction Estimation</h1>
            <p>
              We deliver accurate and data-driven cost estimation services to help you budget confidently and plan efficiently.
            </p>
          </div>
          <img src={estimationHero} alt="Estimation Hero" className="estimation-hero-img" />
        </header>

        <section className="estimation-section">
          <div className="estimation-text">
            <h2>Our Estimation Services</h2>
            <p>
              We use the latest tools and industry standards to prepare detailed estimates, allowing our clients to make informed financial decisions and avoid costly surprises.
            </p>
            <ul>
              <li>Material Quantity Takeoffs</li>
              <li>Labor & Equipment Estimation</li>
              <li>Cost Analysis & Budgeting</li>
              <li>Bid Preparation & Documentation</li>
              <li>BOQ (Bill of Quantities) Preparation</li>
            </ul>
          </div>
          <img src={estimationTools} alt="Estimation Tools" className="estimation-img" />
        </section>

        <section className="estimation-software">
          <h2>Tools & Software We Use</h2>
          <div className="tools-grid">
            <span>AutoCAD</span>
            <span>Excel</span>
            <span>Revit</span>
            <span>Bluebeam</span>
            <span>Planswift</span>
            <span>Estimator 2.0</span>
            <span>CostX</span>
            <span>MS Excel Macros</span>
          </div>
        </section>
        <section className="contact-options">
          <div className="contact-card email">
            <h2>📧 Email</h2>
            <p>Send us an email for inquiries, support or collaboration opportunities.</p>
            <a href="mailto:vinujaya.v7@gmail.com" target="_blank" rel="noopener noreferrer">
              Send Email
            </a>
          </div>

          <div className="contact-card whatsapp">
            <h2>💬 WhatsApp</h2>
            <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
            <a href="https://wa.me/917010658911" target="_blank" rel="noopener noreferrer">
              Chat on WhatsApp
            </a>
          </div>

          <div className="contact-card phone">
            <h2>📞 Call Us</h2>
            <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
            <a href="tel:+917010658911">Call Us</a>
          </div>
        </section>
      </div>
    </>
  );
};

export default EstimationPage;